import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/common.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局 Vue 错误处理：静默捕获，避免 webpack-dev-server 全屏报错
Vue.config.errorHandler = (err, vm, info) => {
  console.warn('[Vue Error]', info, err?.message || err)
}

// 拦截未处理的 Promise 拒绝，防止 webpack overlay 全屏报错
// 所有 API 错误已在 request.js 响应拦截器中通过 Message.error 弹框提示
window.addEventListener('unhandledrejection', event => {
  console.warn('[Unhandled Rejection]', event.reason?.message || event.reason)
  event.preventDefault()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
